<template>
  <div>
    <div class="share-title">Save Block For Reusing</div>
    <v-alert dense text border="left" type="info">
      Save this block to re-use in
      <strong>this</strong> project.
    </v-alert>
    <v-switch
      v-model="block.saved"
      label="Save block to re-use in this project"
      @change="trySaveBlockSavedSettings($event)"
      dense
      flat
      inset
    ></v-switch>
    <v-divider></v-divider>
    <v-alert dense text border="left" type="info" class="mt-3">
      Save this block as universal to re-use across
      <strong>all</strong> your projects.
    </v-alert>
    <v-alert
      dense
      text
      border="left"
      type="warning"
      v-if="user.plan == 'STARTER'"
      >Upgrade your plan to Lite or Premium in order to use this
      feature.</v-alert
    >
    <v-switch
      v-model="block.universal"
      label="Save block for re-use across your all projects"
      @change="trySaveBlockUniversalSettings($event)"
      dense
      flat
      inset
      :disabled="user.plan == 'STARTER'"
    ></v-switch>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import projectMixin from "../project-mixin";
export default {
  props: ["block"],
  mixins: [projectMixin],
  methods: {
    ...mapActions("project", [
      "saveBlockSavedSettings",
      "saveBlockUniversalSettings",
    ]),
    async trySaveBlockSavedSettings(value) {
      const success = await this.saveBlockSavedSettings({
        blockId: this.block.id,
        saved: value,
        universal: this.block.universal,
      });
      if (success) {
        this.block.saved = value;
      } else {
        this.block.saved = !value;
      }
    },
    async trySaveBlockUniversalSettings(value) {
      const success = await this.saveBlockUniversalSettings({
        blockId: this.block.id,
        saved: this.block.saved,
        universal: value,
      });
      if (success) {
        this.block.universal = value;
      } else {
        this.block.universal = !value;
      }
    },
  },
};
</script>

<style scoped>
.share-title {
  font-size: 16px;
  font-weight: bold;
}
</style>